// extracted by mini-css-extract-plugin
export default {"wrapper":"GooglePayButton_wrapper__UAx2o","disabled":"GooglePayButton_disabled__XxpVy"};